export const getAppVersion = (attr) => {
    if (attr.appVersion === 1) {
        return attr.theme === 'unearth-sewer' ? 'Sewer' : 'Construction';
    }
    return 'OPV2';
};

